import { render, staticRenderFns } from "./BankDetailsValue.vue?vue&type=template&id=42df68d4"
import script from "./BankDetailsValue.vue?vue&type=script&lang=js"
export * from "./BankDetailsValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports